import { MonoKicker } from './primitives/MonoKicker';

const props = [
    {
        kicker: '01 · People, on retainer',
        title: "You're hiring, not licensing",
        body: 'A standing team who learn how your practice runs and build around it. Names and a recurring call — not a help centre and a hopeful email.',
    },
    {
        kicker: '02 · Built around you',
        title: 'Configured, never homework',
        body: 'Your note formats, your filing rules, your integrations. We build them from how you already work, and change them when you do.',
    },
    {
        kicker: '03 · The scope grows',
        title: "Starts at the scribe. Doesn't end there.",
        body: "Notes first, because that's the fastest hour back. Then scheduling, outreach, intake, referrals — whatever's next on the list.",
    },
];

export function ValueProps() {
    return (
        <div className="w-full border-y border-border bg-card">
            <div className="mx-auto grid w-full max-w-[1400px] grid-cols-[repeat(auto-fit,minmax(min(280px,100%),1fr))] gap-12 px-[clamp(20px,5vw,72px)] py-[clamp(56px,9vw,88px)]">
                {props.map((item) => (
                    <div
                        key={item.kicker}
                        data-reveal
                        className="flex flex-col gap-4"
                    >
                        <MonoKicker>{item.kicker}</MonoKicker>
                        <h3 className="font-display text-[26px] leading-[1.2] text-primary">
                            {item.title}
                        </h3>
                        <p className="text-[16px] leading-[1.55] text-muted-foreground">
                            {item.body}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
